import * as Yup from 'yup'
import i18n from '../../../../../../translations/i18n'

export const ReassignmentModalSchema = Yup.object().shape({
    assign_to_specific_freelancer: Yup.bool(),
    freelancer: Yup.object().when('assign_to_specific_freelancer', {
        is: true,
        then: Yup.object().required()
    }),
    ignore_freelancer_market: Yup.bool(),
    ignore_freelancer_previous_rejection: Yup.bool(),
    set_a_manual_rate: Yup.bool(),
    rate: Yup.number().when('set_a_manual_rate', {
        is: true,
        then: Yup.number()
            .positive()
            .typeError(i18n.t('errors:number_invalid'))
            .test('maxDigitsAfterDecimal', i18n.t('errors:number_invalid'), amount =>
                /^[0-9]+(?:\.[0-9]{1,2})?$/.test(amount)
            )
    }),
    notes: Yup.string().nullable()
})
